import { render, staticRenderFns } from "./detailsNotify.vue?vue&type=template&id=536b775c&scoped=true&"
import script from "./detailsNotify.vue?vue&type=script&lang=js&"
export * from "./detailsNotify.vue?vue&type=script&lang=js&"
import style0 from "./detailsNotify.vue?vue&type=style&index=0&id=536b775c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b775c",
  null
  
)

export default component.exports